export default "__VITE_ASSET__Dpg_6VG7__"